import "slick-carousel"

$ ->
  if $('#js-rich-content').length > 0
    # slick-carousel [都道府県×ホテル]
    $('.js-slick-slider-image').slick
      infinite: true
      dots: true
      slidesToShow: 1
